import { DependencyList, Dispatch, SetStateAction, useState } from "react";
import { useDidUpdateEffect } from "src/hooks";

// tslint:disable-next-line
const isFunction = (f: any): f is Function => typeof f === "function";

/**
 * Use this hooks like a useState
 * but if a dependency change then
 * the state will be set by initialState
 * @param initialState
 * @param deps
 */
export const useDependentState = <T>(
  initialState: T | (() => T),
  deps: DependencyList
): [T, Dispatch<SetStateAction<T>>] => {
  const [state, setState] = useState<T>(initialState);

  useDidUpdateEffect(() => {
    setState(isFunction(initialState) ? initialState() : initialState);
  }, deps);

  return [state, setState];
};
